import { CYBER_CONSTANT, Constants } from 'constants';

import React from 'react';
import {
  Typography,
  Grid,
  Button,
  Dropdown,
  Tooltip,
  Accordion,
  AccordionItem,
  Autocomplete,
} from '@genie-ui/react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import InfoIcon from '@mui/icons-material/Info';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DialogComponent from 'components/atoms/dialogcomponent';
import { capitalize } from 'utils';
import ConfigPath from 'configpath';
import useIsFromConferenceApp from 'hooks/usePlatform';

function ComparisonDialog({
  openDialogGroup,
  optIn,
  selectedValues,
  dialog,
  handleDropDownOpen,
  handleChange,
  displayList,
  defaultValues,
  setDialogTooltip,
  handleAgree,
  showSubmit,
  actisDataObj,
}) {
  const isFromConferenceApp = useIsFromConferenceApp();
  const { isChinese } = useSelector((state) => state.cyber);
  const accordionClasses = {
    root: 'accordianOptIn',
  };

  const handleActis = () => {
    window.pushEvent?.({
      ...Constants.ACTIS.PRIVACY_POLICY_OPTIN,
      ...actisDataObj,
    }, Constants.LABELS.ACTIS_KEY_CYBER);
  };

  return (
    <DialogComponent
      open={openDialogGroup}
      title={CYBER_CONSTANT.DIALOG.HEADER1}
      modalClass="comparisionDialog"
      hideCloseButton
      content={(
        <div className="dialogSelect">
          <Typography className="drawerText">
            {CYBER_CONSTANT.DIALOG.SUBHEADER}
          </Typography>
          {isChinese && !optIn && (
            <div className="chineseDiv">
              <InfoIcon className="chineseInfoIcon" />
              <div>
                <Typography className="optInText">
                  <b>{CYBER_CONSTANT.OPT_DIALOG.CHINESE_1}</b>
                </Typography>
                <Typography className="optInText chineseTop">
                  <b>{CYBER_CONSTANT.OPT_DIALOG.CHINESE_2}</b>
                </Typography>
                <Typography className="optInText">
                  <b>{CYBER_CONSTANT.OPT_DIALOG.CHINESE_3}</b>
                </Typography>
                <Typography className="optInText">
                  <b>{CYBER_CONSTANT.OPT_DIALOG.CHINESE_4}</b>
                </Typography>
                <Typography className="optInText">
                  <b>{CYBER_CONSTANT.OPT_DIALOG.CHINESE_5}</b>
                </Typography>
                <Typography className="optInText">
                  <b>{CYBER_CONSTANT.OPT_DIALOG.CHINESE_6}</b>
                </Typography>
              </div>
            </div>
          )}
          <div className="filtersBox">
            {Object.keys(selectedValues)?.map((item) => (
              <div key={item} className="filterDiv">
                <Typography className="title">
                  {dialog[item]?.TITLE}
                  {dialog[item]?.showTooltip && (
                    <Tooltip
                      open={dialog[item]?.tooltipVal}
                      className="tooltip-des"
                      hideCloseButton
                      onMouseLeave={() => setDialogTooltip(item, false)}
                      title={(
                        <Typography>
                          {CYBER_CONSTANT.DIALOG[item].SUBHEADER}
                          <br />
                          <i>{CYBER_CONSTANT.DIALOG[item].HELPER}</i>
                        </Typography>
                      )}
                      arrow
                    >
                      <InfoOutlinedIcon
                        className="infoIconFilter"
                        onMouseEnter={() => setDialogTooltip(item, true)}
                      />
                    </Tooltip>
                  )}
                </Typography>
                {item !== 'selectedHeadquarter' ? (
                  <Dropdown
                    openedEvent={() => handleDropDownOpen(item, selectedValues[item])}
                    open={selectedValues[item]?.openDropdown}
                    key={item}
                    menuNode={(
                      <Typography variant="body1">
                        {selectedValues[item]?.desc
                          ? selectedValues[item]?.desc
                          : Constants.LABELS.SELECT}
                      </Typography>
                    )}
                  >
                    {displayList(
                      defaultValues[capitalize(item?.replace('selected', ''))],
                      item,
                    )}
                  </Dropdown>
                ) : (
                  <Autocomplete
                    className="genie-autocomplete-container"
                    options={defaultValues?.headquarter}
                    getOptionLabel={(option) => option?.desc}
                    onChange={(val) => {
                      handleChange(item, '', val);
                    }}
                    onValueSelect={(val) => {
                      handleChange(item, '', val);
                    }}
                    placeHolder={Constants.LABELS.SELECT}
                    inputProps={{
                      value: selectedValues[item]?.desc || '',
                    }}
                    autoHighlight
                    defaultSelectedValue={selectedValues[item]?.desc}
                  />
                )}
              </div>
            ))}
          </div>
          {!optIn && (
            <Accordion classes={accordionClasses} iconPosition="left">
              <AccordionItem title={CYBER_CONSTANT.OPT_DIALOG.HEADER}>
                <Grid container className="dialogOptIn">
                  <Typography className="optInHeader">
                    {CYBER_CONSTANT.OPT_DIALOG.SUBHEADER_1}
                  </Typography>
                  <Typography className="optInText">
                    {CYBER_CONSTANT.OPT_DIALOG.TEXT_1}
                  </Typography>
                  <Typography className="optInText">
                    {CYBER_CONSTANT.OPT_DIALOG.TEXT_2}
                    <a
                      href={ConfigPath.GARTNER_URL + Constants.FOOTER[1].url}
                      target={!isFromConferenceApp ? '_blank' : '_self'}
                      rel="noopener noreferrer"
                      className="optInLink"
                      onClick={handleActis}
                    >
                      {CYBER_CONSTANT.OPT_DIALOG.TEXT_3}
                    </a>
                  </Typography>
                  <Typography className="optInText">
                    {CYBER_CONSTANT.OPT_DIALOG.TEXT_4}
                  </Typography>
                  <Typography className="optInHeader">
                    {CYBER_CONSTANT.OPT_DIALOG.SUBHEADER_2}
                  </Typography>
                  <Typography className="optInText">
                    {CYBER_CONSTANT.OPT_DIALOG.TEXT_5}
                  </Typography>
                  <Typography className="optInText">
                    {CYBER_CONSTANT.OPT_DIALOG.TEXT_6}
                  </Typography>
                </Grid>
              </AccordionItem>
            </Accordion>
          )}
          <Grid container className="kpiGroup">
            <div>
              <Button
                variant="primary"
                className="agreeButton"
                onClick={() => handleAgree(true)}
                disabled={showSubmit}
              >
                {CYBER_CONSTANT.BUTTON.AGREE_BUTTON}
              </Button>
              <Button variant="ghost" onClick={() => handleAgree(false)}>
                {CYBER_CONSTANT.BUTTON.CANCEL}
              </Button>
            </div>
            <Typography className="optInText">
              <i>{CYBER_CONSTANT.DIALOG.REQUIRED}</i>
            </Typography>
          </Grid>
        </div>
      )}
    />
  );
}

ComparisonDialog.propTypes = {
  dialog: PropTypes.instanceOf(Object).isRequired,
  handleAgree: PropTypes.func.isRequired,
  openDialogGroup: PropTypes.instanceOf(Object).isRequired,
  optIn: PropTypes.bool.isRequired,
  selectedValues: PropTypes.instanceOf(Object).isRequired,
  handleDropDownOpen: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  displayList: PropTypes.instanceOf(Object).isRequired,
  defaultValues: PropTypes.instanceOf(Object).isRequired,
  setDialogTooltip: PropTypes.func.isRequired,
  showSubmit: PropTypes.bool.isRequired,
  actisDataObj: PropTypes.instanceOf(Object),
};

ComparisonDialog.defaultProps = {
  actisDataObj: {},
};

export default ComparisonDialog;
